import {
  useEffect, useRef,
} from 'react';

/**
 * @deprecated Do not use at all. It is not needed anymore. The warning has been removed in React 18.
 * https://sentry.io/answers/how-to-fix-react-warning-can-t-perform-a-react-state-update-on-an-unmounted-component/#upgrade-to-react-18
 */
export const useIsComponentMountedRef = () => {
  const isMounted = useRef(true);

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  return isMounted;
};
